import { RoutalPalette } from '@nx-smartmonkey/ui';
import 'rapidoc';
import { Header } from '../components/Header';
import configuration from '../services/configuration';

export const APIDocs = () => {
  return (
    <>
      <Header />

      {/* @ts-expect-error */}
      <rapi-doc
        style={{ height: `calc(100vh - 64px)`, width: `100%` }}
        spec-url={`${configuration.PLANNER_BACK_END}/swagger.json`}
        heading-text="Routal"
        render-style="read"
        theme="light"
        // show-header={false}
        // regular-font="Geist Variant"
        allow-server-selection={false}
        show-header={false}
        fetch-credentials="origin"
        nav-bg-color={RoutalPalette.white}
        primary-color={RoutalPalette.primary40}
        sort-tags
        schema-expand-level={1}
        fill-request-fields-with-example={false}
        server-url="https://api.routal.com/"
        default-api-server="https://api.routal.com/"
      />
    </>
  );
};
